import { DatePipe } from '@angular/common';
import { FieldSpec } from '@k2/common/k2-forms-state/types';

export function datetimeFormatter(datePipe: DatePipe, field: FieldSpec): string {
  return datePipe.transform(field.value, 'short');
}
